import type { CollectionSchemaSyncer } from "./CollectionSchemaSyncer";
import type { CollectionSyncResult } from "./collectionSchemaTypes";

export class CollectionSchemaSyncerHolder {
  constructor(private readonly syncer: CollectionSchemaSyncer | null) {}

  async syncIfAvailable(opts?: { dryRun?: boolean }): Promise<CollectionSyncResult | null> {
    if (!this.syncer) {
      return null;
    }
    return this.syncer.sync(opts);
  }

  hasSync(): boolean {
    return this.syncer !== null;
  }
}
